// extracted by mini-css-extract-plugin
export default {"successContainer":"cartSuccess_successContainer__cHMDa"};